import * as amplitude from '@amplitude/analytics-browser';
import pkg from '../../../package.json';
import { isInWebView } from '~/utils/isWebView';

let isInitialized = false;
let isInitializedWithUser = false;
let currentPlanName: string | undefined;

export function initAmplitude(
  userData?: { id: string; email: string },
  apiKey: string
) {
  if (isInitialized && isInitializedWithUser) return;

  amplitude.init(apiKey);

  if (userData && !isInitializedWithUser) {
    amplitude.setUserId(userData.id.toString());
    const identifyEvent = new amplitude.Identify();

    identifyEvent.set('email', userData.email);

    amplitude.identify(identifyEvent);
    isInitializedWithUser = true;
  }

  isInitialized = true;
}

export function setAmplitudePlanName(planName: string) {
  currentPlanName = planName;
}

export function trackAmplitudeEvent(
  eventName: string,
  eventProps?: Record<string, string | number | boolean>
) {
  if (!isInitialized) {
    console.warn('Amplitude is not initialized.');
    return;
  }

  amplitude.track(eventName, {
    is_webview: isInWebView(),
    version: pkg.version,
    ...(currentPlanName && { plan_name: currentPlanName }),
    ...eventProps,
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateUserProperties(properties: Record<string, any>) {
  if (!isInitialized) return;

  const identifyEvent = new amplitude.Identify();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.entries(properties).forEach(([key, value]) => {
    identifyEvent.set(key, value);
  });

  amplitude.identify(identifyEvent);
}
